import { FilterExpression, serializeFilterExpression } from 'src/app/filters/filter-definition';
import { GetDashboardsVariables } from '../queries/generated/GetDashboards';
import { DashboardTile } from './dashboard-tile.model';

export interface Dashboard {
   name: string | null;
   dashboardId: number;
   lastSavedColumnLayoutSize: number;
   dashboardTiles: DashboardTile[];
   dashboardUserId: number;
}

export function getDashboardsVariables(filterExpression: FilterExpression | null): GetDashboardsVariables {
   const variables = {
      filters: serializeFilterExpression(filterExpression),
   };

   return variables;
}
